<template>
  <div>
    <div v-if="!showSuccessStep">
      <div class="one-by-one-modal__body">
        <template v-if="!scheduleResendModal">
          <div :class="['interview-input-group']" v-for="(candidate, indexAt) in candidate.candidates" :key="indexAt">
            <validation-observer v-slot="{ touched }">
              <validate-form
                :id="`name`"
                type="text"
                v-model="candidate.name"
                :name="resource['hrvenue.createCandidate.Name']"
                rules="required|min:2|validChar"
                :placeholder="resource['hrvenue.candidateNamePlaceholder']"
                @keypress="maxLengthCheck($event, 75, 'name')"
                @keyup="maxLengthCheck($event, 75, 'name')"
                @input="checkValidateRule"
                :classGroup="touched ? 'touched' : 'untouched'"
              >
                <div slot="customLabel">
                  <label :for="`name`" class="form-control-label">
                    {{ resource["hrvenue.createCandidate.Name"] }}
                  </label>
                </div>
              </validate-form>
            </validation-observer>

            <validation-observer v-slot="{ touched }">
              <validate-form
                :id="`surname`"
                :name="resource['hrvenue.createCandidate.Surname']"
                v-model="candidate.surname"
                type="text"
                rules="validChar"
                :placeholder="resource['hrvenue.candidateSurNamePlaceholder']"
                @keypress="maxLengthCheck($event, 75, 'surname')"
                @keyup="maxLengthCheck($event, 75, 'surname')"
                @input="checkValidateRule"
                :classGroup="touched ? 'touched' : 'untouched'"
              >
                <div slot="customLabel">
                  <label :for="`surname`" class="form-control-label">
                    {{ resource["hrvenue.createCandidate.Surname"] }}
                  </label>
                </div>
              </validate-form>
            </validation-observer>

            <validation-observer v-slot="{ touched }">
              <validate-form
                :id="`email`"
                :name="resource['hrvenue.createCandidate.Email']"
                v-model="candidate.email"
                type="text"
                rules="onlyEnglishLetters|required|min:10|max:300|emailRegex"
                :placeholder="resource['hrvenue.candidateEmailPlaceholder']"
                @keypress="maxLengthCheck($event, 300, 'email')"
                @keyup="maxLengthCheck($event, 300, 'email')"
                @input="checkValidateRule"
                :classGroup="touched ? 'touched' : 'untouched'"
              >
                <div slot="customLabel">
                  <label :for="`email`" class="form-control-label">
                    {{ resource["hrvenue.createCandidate.Email"] }}
                  </label>
                </div>
              </validate-form>
            </validation-observer>
          </div>
        </template>
        <div :class="`schedule-area ${scheduleResendModal ? 'schedule-area--schedule-resend' : ''}`" v-if="interviewType === 1">
          <div class="schedule-area__header">
            <h4 v-if="!scheduleResendModal">{{ resource['ScheduleAreaTitle'] }}</h4>
            <span>{{ resource['ScheduleAreaDescriptionOneByOne'] }}</span>
          </div>
          <div class="schedule-area__preview">
            <button
              id="schedule"
              :class="showDatePicker ? null : 'collapsed'"
              :aria-expanded="showDatePicker ? 'true' : 'false'"
              aria-controls="date-collapse"
              @click="showDatePicker = !showDatePicker"
            >
              <div class="d-flex align-items-center justify-content-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M15.8333 3.33366H15V1.66699H13.3333V3.33366H6.66667V1.66699H5V3.33366H4.16667C3.25 3.33366 2.5 4.08366 2.5 5.00033V16.667C2.5 17.5837 3.25 18.3337 4.16667 18.3337H15.8333C16.75 18.3337 17.5 17.5837 17.5 16.667V5.00033C17.5 4.08366 16.75 3.33366 15.8333 3.33366ZM15.8333 16.667H4.16667V8.33366H15.8333V16.667ZM4.16667 6.66699V5.00033H15.8333V6.66699H4.16667ZM5.83333 10.0003H14.1667V11.667H5.83333V10.0003ZM5.83333 13.3337H11.6667V15.0003H5.83333V13.3337Z"
                    fill="#333333"
                  />
                </svg>
                {{
                  localDateRange.startDate &&
                  globalFormatTimeUserLocalWithLang(localDateRange.startDate, language)
                }}
                -
                {{
                  localDateRange.endDate &&
                  globalFormatTimeUserLocalWithLang(localDateRange.endDate, language)
                }}
              </div>
              <span v-if="!showDatePicker">{{ resource['label.Edit'] }}</span>
              <span v-if="showDatePicker" @click="validateDateInputs">{{ resource['label.Save'] }}</span>
            </button>
          </div>
          <b-collapse id="date-collapse" v-model="showDatePicker">
            <DatePicker
              ref="dateRangePicker"
              v-model="localDateRange"
              @update="handleUpdate"
              :isStartDateFixed="false"
              :isDateSet="isDateSet"
            />
          </b-collapse>
          <!-- <div class="schedule-area__divider"></div> -->
          <b-form-checkbox
              class="checkbox-candidate d-flex align-items-center cursor-pointer"
              id="send-mail-checkbox"
              v-model="sendMail"
          >
            {{ resource['ScheduleAreaSendEmailDescription'] }}
          </b-form-checkbox>
          <div v-if="scheduleResendModal && scheduleResendModalWarning" class="warning-info-area">
            <i class="icon-warning-outline"></i>
            <span>{{ resource['scheduleResendModalInfo'] }}</span>
            <i class="icon-close-rounded cursor-pointer" @click="scheduleResendModalWarning = false"></i>
          </div>
          <!-- <b-form-radio-group
            v-model="sendMail"
            :id="'radio-group-send-mail'"
            class="d-flex flex-column"
          >
            <b-form-radio :value="sendMail">{{ resource['ScheduleAreaSendEmailDescription'] }} </b-form-radio>
            <b-form-radio :value="!sendMail"> {{ resource['ScheduleAreaNotSendEmailDescription'] }} </b-form-radio>
          </b-form-radio-group> -->
        </div>
        <!-- <div v-if="showDatePickerError" class="error-info-area mt-3">
          <i class="icon-warning-outline"></i>
          <span>{{ resource['ScheduleAreaSelectionError'] }}</span>
          <i class="icon-close-rounded cursor-pointer" @click="showDatePickerError = false"></i>
        </div> -->
        <!-- <div v-if="showDatePickerSaveError" class="error-info-area mt-3">
            <i class="icon-warning-outline"></i>
            <span>{{ resource['ScheduleAreaSelectionSaveError'] }}</span>
            <i class="icon-close-rounded cursor-pointer" @click="showDatePickerSaveError = false"></i>
          </div> -->
        <!-- <div v-if="showDatePickerSuccess" class="success-info-area">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M10 1.66602C5.4 1.66602 1.66667 5.39935 1.66667 9.99935C1.66667 14.5993 5.4 18.3327 10 18.3327C14.6 18.3327 18.3333 14.5993 18.3333 9.99935C18.3333 5.39935 14.6 1.66602 10 1.66602ZM10 16.666C6.325 16.666 3.33333 13.6743 3.33333 9.99935C3.33333 6.32435 6.325 3.33268 10 3.33268C13.675 3.33268 16.6667 6.32435 16.6667 9.99935C16.6667 13.6743 13.675 16.666 10 16.666ZM13.825 6.31602L8.33333 11.8077L6.175 9.65768L5 10.8327L8.33333 14.166L15 7.49935L13.825 6.31602Z" fill="#19552E"/>
          </svg>
          <span>{{ resource['ScheduleAreaSelectionSuccess'] }}</span>
        </div> -->
      </div>
      <div class="one-by-one-modal__footer">
        <b-button v-if="currentStep > 1 && totalSteps > 1" name="back" class="border-button-create" @click="$emit('prev')">
          <span>{{ resource['addCandidateModalBackBtn'] }}</span>
        </b-button>
        <b-button v-else name="cancel" class="border-button-create" @click="hiddenModal">
          <span>{{ resource['addCandidateModalCancelBtn'] }}</span>
        </b-button>
        <b-button v-if="currentStep < totalSteps && totalSteps > 1" name="next" class="bg-button gap-2 d-flex align-items-center" @click="$emit('next')">
          <span>{{ resource['addCandidateModalNextBtn'] }}</span>
        </b-button>
        <b-button
          v-else
          v-b-tooltip.hover
            :title="
              invalid
                ? resource['label.Enter.RequiredFields']
                : ''
            "
          name="add"
          class="bg-button gap-2 d-flex align-items-center"
          :class="[invalid ? 'disabled' : '']"
          :disabled="invalid || buttonLoading"
          @click="submitHandler()"
        >
          <template v-if="!scheduleResendModal">
            <i
              v-if="buttonLoading"
              class="icon-spinner icon-spin"
              width="20"
              height="20"
            />
            <span>{{ isDateSet ? resource['scheduleEditModalBtn'] : resource['addCandidateModalSubmitBtn'] }}</span>
          </template>
          <template v-else>
            <i
              v-if="buttonLoading"
              class="icon-spinner icon-spin"
              width="20"
              height="20"
            />
            <i
              v-if="!buttonLoading"
              class="icon-resend"
              width="20"
              height="20"
            />
            <span>{{ resource['scheduleResendModalBtn'] }}</span>
          </template>
        </b-button>
      </div>
    </div>
    <div v-else>
      <div class="one-by-one-modal__body">
        <div class="one-by-one-modal__success">
          <img v-if="!scheduleResendModal" class="sended-mail-icon" :src="require('@/assets/hrVenue/add-candidate-succes.svg')" />
          <img v-if="scheduleResendModal" class="sended-mail-icon" :src="'/images/resend-email.svg'" />
          <h3 v-if="!scheduleResendModal">{{isDateSet ? resource['scheduleEditModalSuccessTitle'] : resource['addCandidateModalSuccessTitle']}}</h3>
          <h3 v-else-if="scheduleResendModal">{{ sendMail ? resource['scheduleResendModalSuccessSendMailTitle'] : resource['scheduleResendModalSuccessNotSendMailTitle']}}</h3>
          <div v-if="interviewType === 1">
            <template v-if="!scheduleResendModal">
              <span v-if="sendMail">{{isDateSet ? resource['scheduleEditModalDescription'] : resource['addCandidateModalOneSuccessSendMailDescription']}}</span>
              <span v-else>{{resource['addCandidateModalOneSuccessNotSendMailDescription']}}</span>
            </template>
            <template v-else-if="scheduleResendModal">
              <span v-if="sendMail">{{resource['scheduleResendModalSuccessSendMailDescription']}}</span>
              <span v-else>{{resource['scheduleResendModalSuccessNotSendMailDescription']}}</span>
            </template>
          </div>

          <div class="candidate-link-area" v-if="interviewType === 1 && !bulkSchedule && sendedCandidates?.[0]?.url">
            <p>{{resource['addCandidateModalOneSuccessLinkLabel']}}</p>
            <input type="text" :value=sendedCandidates?.[0]?.url class="candidate-link-area__input" readOnly />
            <div class="candidate-link-area__button cursor-pointer" style="background: transparent !important;"
              @click=copyURL(sendedCandidates?.[0]?.url)>

              <svg v-if="!isCopy" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.9167 16.666H4.58335V5.83268C4.58335 5.37435 4.20835 4.99935 3.75002 4.99935C3.29169 4.99935 2.91669 5.37435 2.91669 5.83268V16.666C2.91669 17.5827 3.66669 18.3327 4.58335 18.3327H12.9167C13.375 18.3327 13.75 17.9577 13.75 17.4993C13.75 17.041 13.375 16.666 12.9167 16.666ZM17.0834 13.3327V3.33268C17.0834 2.41602 16.3334 1.66602 15.4167 1.66602H7.91669C7.00002 1.66602 6.25002 2.41602 6.25002 3.33268V13.3327C6.25002 14.2493 7.00002 14.9993 7.91669 14.9993H15.4167C16.3334 14.9993 17.0834 14.2493 17.0834 13.3327ZM15.4167 13.3327H7.91669V3.33268H15.4167V13.3327Z" fill="#FF8D06"/>
              </svg>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M7.32915 13.2305L4.43749 10.3388C4.11249 10.0138 3.58749 10.0138 3.26249 10.3388C2.93749 10.6638 2.93749 11.1888 3.26249 11.5138L6.74582 14.9971C7.07082 15.3221 7.59582 15.3221 7.92082 14.9971L16.7375 6.18047C17.0625 5.85547 17.0625 5.33047 16.7375 5.00547C16.4125 4.68047 15.8875 4.68047 15.5625 5.00547L7.32915 13.2305Z" fill="#49CA77"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="one-by-one-modal__footer">
        <b-button
          v-if="scheduleResendModal && !bulkSchedule"
          name="add"
          class="bg-button gap-2 d-flex align-items-center"
          @click="$emit('onHide')"
        >
          <span>{{resource['scheduleResendModalBackBtn']}}</span>
        </b-button>
        <b-button
          v-if="scheduleResendModal && bulkSchedule"
          name="add"
          class="bg-button d-flex align-items-center download-btn"
          @click="successPageHandler"
        >
          <span>
            {{ resource["addCandidateModalDownloadExcelBtn"] }}
          </span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M11.9998 9.99935V11.9993H3.99984V9.99935H2.6665V11.9993C2.6665 12.7327 3.2665 13.3327 3.99984 13.3327H11.9998C12.7332 13.3327 13.3332 12.7327 13.3332 11.9993V9.99935H11.9998ZM11.3332 7.33268L10.3932 6.39268L8.6665 8.11268V2.66602H7.33317V8.11268L5.6065 6.39268L4.6665 7.33268L7.99984 10.666L11.3332 7.33268Z"
              fill="white"
            />
          </svg>
        </b-button>
        <b-button
          v-if="!scheduleResendModal"
          name="add"
          class="bg-button gap-2 d-flex align-items-center"
          @click="$emit('onHide')"
        >
          <span v-if="!sendMail">{{resource['addCandidateModalOkayBtn']}}</span>
          <span v-else>{{resource['addCandidateModalBackListBtn']}}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ResourceManager from '@/services/resource.service';
import DatePicker from '../../common/DatePicker.vue';
import { showNotification } from '../../../static/helpers';

export default {
  name: 'oneByOneModal',
  components: {
    DatePicker,
  },
  props: {
    candidate: { type: Object, required: true },
    dateRange: { type: Object, required: true },
    invalid: { type: Boolean, default: true },
    buttonLoading: { type: Boolean, default: false },
    currentStep: { type: Number, default: 0 },
    totalSteps: { type: Number, default: 0 },
    showSuccessStep: { type: Boolean, default: false },
    sendedCandidates: { type: Array, default: () => [] },
    unSendedCandidates: { type: Array, default: () => [] },
    interviewType: { type: Number, default: 1 },
    isDateSet: { type: Boolean, default: false },
    scheduleResendModal: { type: Boolean, default: false },
    bulkSchedule: { type: Boolean, default: false },
    candidateStatus: { type: Number, default: null },
  },
  data() {
    return {
      showDateModalError: false,
      showDatePicker: false,
      sendMail: true,
      datePickerValid: true,
      showDatePickerError: false,
      showDatePickerSaveError: false,
      showDatePickerSuccess: false,
      language: 'en-US',
      isCopy: false,
      localDateRange: { ...this.dateRange },
      scheduleResendModalWarning: true,
    };
  },
  created() {
    this.language = typeof ResourceManager.CurrentLang !== 'string' ? ResourceManager.CurrentLang.key : ResourceManager.CurrentLang;
    if (this.candidate.candidates.length) {
      if ((this.candidate.candidates[0].name && this.candidate.candidates[0].surname && this.candidate.candidates[0].email) || this.bulkSchedule) {
        this.showDatePicker = true;
      } else {
        this.showDatePicker = false;
      }
    }
  },
  methods: {
    successPageHandler() {
      this.$emit('downloadExcel');
    },
    submitHandler() {
      if (this.showDatePicker) {
        this.showDatePickerSaveError = true;
        this.showDatePickerSuccess = false;
        this.showDatePickerError = false;
        this.scrollToBottom();
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionSaveError,
          'error',
        );
        return;
      }
      if (!this.datePickerValid) {
        this.showDatePickerSaveError = false;
        this.showDatePickerSuccess = false;
        this.showDatePickerError = true;
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionError,
          'error',
        );
        this.scrollToBottom();
        return;
      }
      if (!this.buttonLoading && this.datePickerValid) {
        const values = {
          dateRange: this.localDateRange,
          sendMail: this.sendMail,
        };
        this.$emit('submit', values);
      }
    },
    handleUpdate(value) {
      this.localDateRange = { ...value };
      this.$emit('update:dateRange', this.localDateRange);
    },
    shownModal() {
      //
    },

    hiddenModal() {
      this.$emit('onHide');
      this.localDateRange = {
        startDate: new Date(),
        endDate: new Date(new Date().setDate(new Date().getDate() + 7)),
        startTime: null,
        endTime: null,
        selectedDuration: '7',
      };
      this.showDateModalError = false;
      this.showDatePicker = false;
      this.sendMail = true;
      this.datePickerValid = true;
    },
    validateDateInputs() {
      const {
        startDate, endDate, startTime, endTime, selectedDuration,
      } = this.localDateRange;
      const isValid = [startDate, endDate, startTime, endTime, selectedDuration].every(Boolean);

      this.showDateModalError = !isValid;
      this.datePickerValid = isValid;
      this.showDatePickerSuccess = isValid;
      this.showDatePickerError = !isValid;
      this.showDatePickerSaveError = false;

      if (isValid) {
        showNotification(
          this.resource['Label.Success'],
          this.resource.ScheduleAreaSelectionSuccess,
          'success',
        );
      } else {
        showNotification(
          this.resource['Label.Error'],
          this.resource.ScheduleAreaSelectionError,
          'error',
        );
      }
      this.scrollToBottom();

      return isValid;
    },
    checkValidateRule() {
      this.$emit('onValidateField', this.candidate.candidates[0]);
    },
    setWhichInput(InpEl, value) {
      if (InpEl === 'name') {
        this.candidate.candidates[0].name = value;
      } else if (InpEl === 'surname') {
        this.candidate.candidates[0].surname = value;
      } else {
        this.candidate.candidates[0].email = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;

      if (!maxLength || String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.one-by-one-modal__body');
        if (modalBody) {
          modalBody.scrollTo({
            top: modalBody.scrollHeight,
            behavior: 'smooth',
          });
        }
      });
    },
    async copyURL(url) {
      await navigator.clipboard.writeText(url).then(() => {
        this.isCopy = true;
        setTimeout(() => {
          this.isCopy = false;
        }, 3000);
      });
    },
  },
  watch: {
    showDatePicker(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.scrollToBottom();
        }, 250);
      }
    },
    dateRange: {
      handler(newVal) {
        this.localDateRange = { ...newVal };
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/style/starter.scss";
.schedule-area {
  width: 100%;
  display: flex;
  margin-top: 24px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  border-radius: 4px;
  border: 1px solid var(--Stroke-Colors-Primary-Gray-Stroke, #e5e5e5);
  background: var(--Background-Colors-Bright-Gray, #fafafa);

  &--schedule-resend {
    background: #FFF !important;
    border: #FFF !important;
    margin-top: 0 !important;
    padding: 0 !important;
  }

  &__divider {
    width: 100%;
    height: 1px;
    background: var(--Stroke-Colors-Primary-Gray-Stroke, #e5e5e5);
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--Padding-Small, 4px);
    align-self: stretch;

    h4 {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Subtitle/3 - Medium */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    span {
      color: var(--Text-Colors-Secondary-Gray-Text, #878787);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Body/3 - Regular */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }

  &__preview {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
    width: 100%;

    p {
      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: "liga" off, "clig" off;
      /* Typography/Subtitle/3 - Medium */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;
    }

    button {
      width: 100%;
      display: flex;
      padding: var(--Padding-Regular, 8px);
      align-items: center;
      justify-content: space-between;
      gap: var(--Padding-Small, 4px);
      border-radius: 4px;
      border: 1px solid var(--Stroke-Colors-Tertiary-Gray-Stroke, #e5e5e5);
      background: var(--Background-Colors-White, #fff);

      color: var(--Text-Colors-Primary-Gray-Text, #333);
      font-feature-settings: "liga" off, "clig" off;
      text-overflow: ellipsis;
      /* Typography/Body/3 - Regular */
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;

      @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
        height: auto;
      }

      span {
        color: var(--Text-Colors-Primary-Gray-Text, #ff8d06);
        font-feature-settings: "liga" off, "clig" off;
        text-overflow: ellipsis;
        /* Typography/Body/3 - Regular */
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px;
      }
    }
  }
  ::v-deep .custom-control-label {
    color: #333 !important;
    font-feature-settings: 'liga' off, 'clig' off;
    /* Typography/Body/3 - Regular */
    font-family: Roboto;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: 20px !important;
    padding-top: 2px !important;
  }
}
::v-deep {
  .one-by-one-modal {
    .form-control {
      width: 100%;
    }
  }

  .form-group label {
    color: var(--Text-Colors-Primary-Gray-Text, #333);
    font-feature-settings: "liga" off, "clig" off;
    /* Typography/Subtitle/3 - Medium */
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    margin-bottom: 4px;
  }

  .form-control {
    display: flex;
    padding: var(--Padding-Regular, 8px);
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid #e5e5e5 !important;
    background: #fff;
    box-shadow: none !important;
    color: #333;
    font-feature-settings: "liga" off, "clig" off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .form-control-feedback {
    display: none !important;
  }
  .untouched {
    &.has-danger .form-control {
      border-color: #e5e5e5 !important;
      color: #333 !important;
      box-shadow: none !important;
    }
  }

  .error-info-area {
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Light-Red-Stroke, #F2B5B5);
    background: var(--Background-Colors-Light-Red, #F8DADA);

    span {
      color: var(--Text-Colors-Red-Text, #631212);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      flex: 1;
    }

    i {
      font-size: 20px;
    }
  }
  .warning-info-area {
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Light-Red-Stroke, #FFEDB5);
    background: var(--Background-Colors-Light-Red, #FFF6DA);

    span {
      color: var(--Text-Colors-Red-Text, #826300);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      flex: 1;
    }

    i {
      font-size: 20px;
    }
  }

  .success-info-area {
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    align-self: stretch;
    border-radius: 4px;
    border: 1px solid var(--Stroke-Colors-Light-Red-Stroke, #B6EAC9);
    background: var(--Background-Colors-Light-Red, #DBF4E4);
    margin-top: 16px;

    span {
      color: var(--Text-Colors-Red-Text, #19552E);
      font-feature-settings: 'liga' off, 'clig' off;
      /* Typography/Small Text/1 - Regular */
      font-family: Roboto;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;
      flex: 1;
    }
  }
  .checkbox-candidate {
    .custom-control-label {
      cursor: pointer;
      &:hover {
        &::after {
          background: #FFE9CE;
        }
      }
      &::after {
        border: 1px solid #333;
        border-radius: 2px;
      }
      &::before {
        border-color: transparent !important;
        outline: none;
        box-shadow: none;
        width: 16px !important;
        height: 16px !important;
      }
    }
    .custom-control-input {
      cursor: pointer;
      &:focus {
        border-color: transparent !important;
      }
      &:checked {
        & ~ .custom-control-label {
          &::before {
            content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M5.86337 10.5836L3.55004 8.27026C3.29004 8.01026 2.87004 8.01026 2.61004 8.27026C2.35004 8.53026 2.35004 8.95026 2.61004 9.21026L5.39671 11.9969C5.65671 12.2569 6.07671 12.2569 6.33671 11.9969L13.39 4.94359C13.65 4.68359 13.65 4.26359 13.39 4.00359C13.13 3.74359 12.71 3.74359 12.45 4.00359L5.86337 10.5836Z" fill="white"/></svg>') !important;
            color: $white !important;
            background: $purple !important;
            font-size: 14px;
            text-align: center;
            position: absolute;
            left: -25px;
            border-radius: 2px;
          }
          &::after {
            display: none !important;
          }
        }
      }
    }
  }
}
</style>
